import React  from 'react';
import ReactPlayer from 'react-player';

export const SeccVideo = () => {

    // const buttonMedia = () => {
    //     if (window.innerWidth >= 900) {
    //         document.getElementById("scroll-desktop").scrollIntoView({behavior: "smooth"});
    //     }else{
    //         document.getElementById("scroll-mobile").scrollIntoView({behavior: "smooth"});
    //     }

    // }

    return (
        <div className="main-video">
            <a href="https://amnistia.org.mx/contenido/index.php/dona/" target="_blank" rel="noreferrer"><div className="boton-dona">DONA</div></a>
            <div className="header-video" >
                <div className="header-imagen">
                    <div className="header-hashtag" >
                        <div className="hashtag-contenido" >
                            <div className="hashtag-contenido-texto" >
                                <p className="hashtag-texto" >#HastaSerEscuchadas</p>
                                <div className="hashtag-logo"></div>
                            </div>
                        </div>
                </div>
                </div>
            </div>
            <div className="header-video-mobile" >
                <div className="header-imagen-mobile">
                    <div className="header-amnistia-mobile"></div>
                </div>

                <div className="header-hashtag-mobile" >
                    <div className="hashtag-contenido-mobile" >
                        <div className="hashtag-contenido-texto-mobile" >
                            <p className="hashtag-texto-mobile" >#HastaSerEscuchadas</p>
                            <div className="hashtag-logo-mobile"></div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="video-iframe-container">
                <div className="media-video">
                    <div className="media-contenido">
                        <div className="media-contenido-video">
                            <ReactPlayer 
                                url='https://www.youtube.com/watch?v=n-gflXZ_ICQ' 
                                width='100%'
                                height='100%'
                                playing={true}
                                controls={true}
                                volume={0}
                                loop={true}
                                className="react-player"
                            />
                        </div>
                    </div>
                </div>
                <div className="iframe-right" id="scroll-desktop" >
                    <iframe id="iframeDesktop" src="https://amnistia.org.mx/peticiones/hastaserescuchadas/firma.php" width="100%" height="100%" frameBorder="0" title="firma"></iframe>
                </div>
            </div>

            <div className="media-video-mobile">
                <div className="media-contenido-mobile">  
                    <div className="media-contenido-video-mobile">
                        <ReactPlayer 
                            url='https://www.youtube.com/watch?v=n-gflXZ_ICQ' 
                            width='100%'
                            height='100%'
                            playing={true}
                            controls={true}
                            volume={0}
                            loop={true}
                            className="react-player-mobile"
                        />
                    </div> 
                </div>
            </div>

            
            {/* <div className="texto-video-mobile">
                <div className="texto-contenido-mobile">
                    <p className="texto-contenido-titulo-mobile" >En el Estado de México</p>
                    <p className="texto-contenido-subtitulo-mobile" >hay familias que siguen buscando justicia. </p>
                </div>
            </div> */}
        </div>
    )
}
